import { render, staticRenderFns } from "./cus-radio.vue?vue&type=template&id=8575272e&lang=pug&"
import script from "./cus-radio.vue?vue&type=script&lang=js&"
export * from "./cus-radio.vue?vue&type=script&lang=js&"
import style0 from "./cus-radio.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports